import { createFileRoute } from "@tanstack/react-router";

import { DashboardShell } from "@/components/dashboard-shell";
import { CompetitorDetail } from "@/components/competitors/competitor-detail";
import { CardGridSkeleton, RouteLoading } from "@/components/route-loading";

export const Route = createFileRoute("/competitors/$id")({
  component: CompetitorDetailRoute,
  head: () => ({ meta: [{ title: "Competitor" }] }),
  pendingComponent: CompetitorDetailPending,
});

function CompetitorDetailRoute() {
  const { id } = Route.useParams();
  return (
    <DashboardShell>
      <CompetitorDetail id={id} />
    </DashboardShell>
  );
}

function CompetitorDetailPending() {
  return (
    <RouteLoading>
      <CardGridSkeleton count={4} />
    </RouteLoading>
  );
}
